import { useQuery } from '@shared/modules/use-query/hooks'
import { Service } from '../types'
import { useCallback, useMemo } from 'react'
import { ServicesService } from '../services'

export const useServiceList = () => {
  return useQuery<Service[]>(
    useCallback(async () => {
      const result = await ServicesService.getAll({ page: 1, per_page: 5000 })
      if (result.status === 200) {
        return result.data
      } else {
        throw new Error(result.data)
      }
    }, []),
    useMemo(() => ({ initialData: [] }), []),
  )
}
